import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import logger from './utils/logger';

function AdminFeedback({ authToken }) {
  const [feedback, setFeedback] = useState([]);
  const [error, setError] = useState(null);
  const [expandedDates, setExpandedDates] = useState({});
  const navigate = useNavigate();

  const toggleDate = (date) => {
    setExpandedDates(prev => ({
      ...prev,
      [date]: !prev[date]
    }));
  };

  useEffect(() => {
    const fetchFeedback = async () => {
      logger.info("Auth token received:", {
        token: authToken,
        length: authToken?.length,
        type: typeof authToken
      });
      logger.info("Token starts with Bearer?", authToken.startsWith('Bearer '));

      try {
        // Decode token to verify its contents
        const tokenParts = authToken.split('.');
        logger.info("Token parts:", tokenParts.length);
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          logger.info("Token payload:", payload);
        }
      } catch (e) {
        logger.error("Error decoding token:", {
          error: e,
          token: authToken
        });
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/feedback`, {
          headers: {
            'Authorization': authToken.startsWith('Bearer ') ? authToken : `Bearer ${authToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });

        logger.info("Response status:", response.status);
        const responseText = await response.text();
        logger.info("Response body:", responseText);

        if (!response.ok) {
          if (response.status === 401) {
            logger.info("Token validation failed, redirecting to login");
            navigate('/');
            return;
          }
          throw new Error('Failed to fetch feedback');
        }

        const data = JSON.parse(responseText);
        logger.info("Feedback data:", data);
        setFeedback(data);
      } catch (err) {
        logger.error("Error fetching feedback:", err);
        setError(err.message);
      }
    };

    fetchFeedback();
  }, [authToken, navigate]);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h2 style={{ margin: 0 }}>User Feedback</h2>
        <button 
          onClick={() => navigate('/')}
          style={{
            padding: '8px 16px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Back to App
        </button>
      </div>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {feedback.map((dateGroup) => (
        <div key={dateGroup.date}>
          <div
            onClick={() => toggleDate(dateGroup.date)}
            style={{ 
              marginTop: '30px', 
              marginBottom: '20px',
              color: '#666',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              userSelect: 'none'
            }}>
            {expandedDates[dateGroup.date] ? <FaChevronDown /> : <FaChevronRight />}
            <h3 style={{ margin: '0 10px' }}>
              {new Date(dateGroup.date).toLocaleDateString('en-US', { 
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </h3>
            <span style={{ 
              backgroundColor: '#e0e0e0', 
              padding: '2px 8px', 
              borderRadius: '12px', 
              fontSize: '0.9em' 
            }}>
              {dateGroup.feedback.length} feedback{dateGroup.feedback.length !== 1 ? 's' : ''}
            </span>
          </div>
          {expandedDates[dateGroup.date] && (
            dateGroup.feedback.map((item) => (
              <div 
                key={item.id}
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  padding: '15px',
                  marginBottom: '15px',
                  backgroundColor: 'white'
                }}
              >
                <div style={{ marginBottom: '10px' }}>
                  <strong>Category:</strong> {item.category}
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <strong>Submitted by:</strong> {item.username}
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <strong>Feedback:</strong>
                  <div style={{ padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                    {item.feedback}
                  </div>
                </div>
                <div style={{ color: '#666', fontSize: '0.9em' }}>
                  Submitted: {new Date(item.created_at).toLocaleString()}
                </div>
              </div>
            ))
          )}
        </div>
      ))}
    </div>
  );
}

export default AdminFeedback; 